import axiosInstance from "../axiosInterceptor";

export async function verifyOTP(body) {
  try {
    const response = await axiosInstance.post(`student/verifyOTP`, body);
    const data = response?.data;
    return data;
  } catch (error) {
    return error.response?.data;
  }
}
